import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import MDBox from "shared/components/MDBox";

import HeaderComercio from "./components/Comercio/HeaderComercio";
import TablaComercio from "./components/Comercio/TablaComercio";
import HeaderEquipo from "./components/Equipo/HeaderEquipo";
import TablaEquipo from "./components/Equipo/TablaEquipo";
import HeaderZona from "./components/Zona/HeaderZona";
import TablaZona from "./components/Zona/TablaZona";
import HeaderTipoActividad from "./components/TipoActividad/HeaderTipoActividad";
import TablaTipoActividad from "./components/TipoActividad/TablaTipoActividad";

const Configuracion = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleUserCreated = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />

      <Grid container spacing={3}>
        {/* Comercio */}
        <Grid item xs={12} md={6}>
          <HeaderComercio onCommerceCreated={handleUserCreated}>
            <MDBox mt={2}>
              <TablaComercio refreshFlag={refreshFlag} />
            </MDBox>
          </HeaderComercio>
        </Grid>
        {/* Zona */}
        <Grid item xs={12} md={6}>
          <HeaderZona onZoneCreated={handleUserCreated}>
            <MDBox mt={2}>
              <TablaZona refreshFlag={refreshFlag} />
            </MDBox>
          </HeaderZona>
        </Grid>
        {/* Equipo */}
        <Grid item xs={12} md={6}>
          <HeaderEquipo onDeviceCreated={handleUserCreated}>
            <MDBox mt={2}>
              <TablaEquipo refreshFlag={refreshFlag} />
            </MDBox>
          </HeaderEquipo>
        </Grid>
        {/* Tipo de Actividad */}
        <Grid item xs={12} md={6}>
          <HeaderTipoActividad onActivityTypeCreated={handleUserCreated}>
            <MDBox mt={2}>
              <TablaTipoActividad refreshFlag={refreshFlag} />
            </MDBox>
          </HeaderTipoActividad>
        </Grid>
      </Grid>

      <Footer />
    </DashboardLayout>
  );
};

export default Configuracion;
